import { Loader2 } from 'lucide-react';

export default function PDFLoadingState() {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[400px] animate-fade-in">
      <Loader2 className="w-12 h-12 animate-spin text-[hsl(var(--primary))] mb-4" />
      <p className="text-lg font-semibold text-foreground mb-2">Loading PDF...</p>
      <p className="text-muted-foreground text-center">Please wait while the document is being prepared.</p>
    </div>
  );
}
